import { isEdgeVariantSelection } from './rendering-selection-state'

export function hasElementBeenEdgeTrimmed(htmlId: string) {
  if (isEdgeVariantSelection()) {
    // oxlint-disable-next-line unicorn/prefer-query-selector
    const scriptElement = document.getElementById(htmlId)

    if (!scriptElement?.hasChildNodes()) {
      return true
    }
  }

  return false
}
